const regex = {
	email: /^\S+@\S+\.\S+$/,
};

export default regex;
